import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-duihuan",
  "use": "icon-duihuan-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-duihuan\"><path d=\"M907.832889 455.111111 454.599111 455.111111 225.678222 455.111111 454.599111 227.555556 454.599111 341.333333 871.708444 341.333333C807.253333 207.303111 670.947556 113.777778 511.829333 113.777778 310.385778 113.777778 143.701333 262.428444 115.825778 455.111111L0.170667 455.111111C28.615111 199.111111 246.727111 0 511.829333 0 776.874667 0 994.986667 199.111111 1023.488 455.111111L912.384 455.111111 907.832889 455.111111ZM115.825778 568.888889 511.829333 568.888889 740.693333 568.888889 511.829333 796.444444 511.829333 682.666667 151.950222 682.666667C216.348444 816.696889 352.654222 910.222222 511.829333 910.222222 713.216 910.222222 879.900444 761.514667 907.832889 568.888889L1023.488 568.888889C994.986667 824.832 776.874667 1024 511.829333 1024 246.727111 1024 28.615111 824.832 0.170667 568.888889L53.987556 568.888889 115.825778 568.888889Z\" p-id=\"6045\" fill=\"#000000\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/duihuan.svg
// module id = hv1U
// module chunks = 27